import { formatBytes } from '../../components/formatBytes';

/** Vertrag 2.6: Emoji-Namen `^[A-Za-z0-9_]{2,32}$`. */
export const EMOJI_NAME_RE = /^[A-Za-z0-9_]{2,32}$/;
export const STICKER_ACCEPT = 'image/png,image/apng,image/gif,image/webp,application/json,.json';
export const SOUND_ACCEPT = 'audio/mpeg,audio/ogg,audio/wav,audio/x-wav,audio/wave,.mp3,.ogg,.wav';

/** Emoji-Name aus Dateiname ableiten (ungültige Zeichen → `_`, auf 2–32 Zeichen gebracht). */
export function emojiNameFromFile(filename: string): string {
  let n = filename
    .replace(/\.[^.]+$/, '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9_]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 32);
  if (n.length < 2) n = `emoji_${n}`.slice(0, 32);
  return n;
}

/** Prüft MIME-Typ/Endung gegen `accept` und die Größe; liefert Fehlermeldung oder null. */
export function fileTypeAllowed(file: File, accept: string, maxBytes: number): string | null {
  const parts = accept.split(',').map((s) => s.trim().toLowerCase());
  const ext = `.${file.name.split('.').pop()?.toLowerCase() ?? ''}`;
  const ok = parts.some((p) => (p.startsWith('.') ? p === ext : p === file.type.toLowerCase()));
  if (!ok) return 'Dieses Dateiformat wird nicht unterstützt.';
  if (maxBytes > 0 && file.size > maxBytes) return `Die Datei ist zu groß (höchstens ${formatBytes(maxBytes)}).`;
  return null;
}
